import { SvgIcon } from './SvgIcon.jsx';

const id = 'close-icon';

export const CloseIconSymbol = () => (
	<symbol id={id} viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
		<line x1="2" y1="2" x2="22" y2="22" />
		<line x1="2" y1="22" x2="22" y2="2" />
	</symbol>
);

export const CloseIcon = ({ className, size = '24', hidden = false }) => (
	<SvgIcon className={className} width={size} height={size} hidden={hidden}>
		<use xlinkHref={`#${id}`} />
	</SvgIcon>
);
